import React from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { BiHotel } from "react-icons/bi";
import { MdOutlineHomeWork, MdOutlinePayment } from "react-icons/md";
import { IoBedOutline } from "react-icons/io5";
import { RxDimensions } from "react-icons/rx";
import { CiCalendarDate } from "react-icons/ci";
import { MdOutlinePool, MdElevator } from "react-icons/md";
import { MdOutlineWifi, MdBalcony } from "react-icons/md";
import { RiParkingBoxFill } from "react-icons/ri";
import { SlScreenDesktop } from "react-icons/sl";
import { IoRestaurant } from "react-icons/io5";
import { LuMicrowave, LuArmchair } from "react-icons/lu";
import { GiBathtub } from "react-icons/gi";
import { FaKitchenSet } from "react-icons/fa6";
import { FaUser, FaBellConcierge } from "react-icons/fa6";
import { GiMoneyStack, GiCctvCamera } from "react-icons/gi";
import { MdOutlineRoomPreferences, MdOutlineSevereCold } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { useState, useEffect } from "react";
import Loading from "../../../COMPONENTS/Loading/Loading";
import { GoArrowLeft } from "react-icons/go";
import SidebarTop from "../../SidebarTop";
import { TbFridge } from "react-icons/tb";
import { IoMdPin, IoIosMail } from "react-icons/io";
import Heber from "../../../../API/tourisme/hebergement/edit";
import { ToastContainer, toast } from "react-toastify";
import { FaPhoneAlt } from "react-icons/fa";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { loadStripe } from '@stripe/stripe-js';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import { Button,Form } from "react-bootstrap";
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import Create from "../../../../Payment/Create";


function EditHebergement() {
  localStorage.setItem(
    "url",
    JSON.stringify("/Dashboard/Publications/Hebergement/Voir_des_hebergements")
  );

  const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });

  const navigate = useNavigate();

  const [records, setRecords] = useState([]);
  const [tmprecords, setTmpecords] = useState([]);
  const [changed, setChanged] = useState();

  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({});

  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [address, setAddress] = useState([]);
  const [showInput,setShowInput] = useState(false)
  const [errors,setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [priceD, setPriceD] = useState(null);
  const [pricePub, setPricePub] = useState(null);
  const [pictures,setPictures] = useState([]);
  const [dayr,setDayr] = useState(null)
  const [open,setOpen] = useState(false)
  const [options, setOptions] = useState(null);
  const [curr,setCurr] = useState();
  
  

  let fd = new FormData();
  
  const getPricePub = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/pub/hebergement`);
          //console.log("Le prix provenant de la base est "+ res.data.data.Prices);
          setPricePub(res.data.data.Prices);
          localStorage.setItem('pricePub', res.data.data.Prices);
        
      } catch (err) {
          console.log(err);
        }
      };

   const getPriceDollar = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/dollar`);
            setPriceD(res.data.data.value_to_xof);
          } catch (err) {
            console.log(err);
          }
        };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setChanged(true);
    setFormData({ ...formData, [name]: value });
  };

  const location = useLocation();
  const id = location.state;

  const handleCountryChange = (selectedOption) => {
    // selectedOption contient directement l'objet { label, value }
    setProvinces([]);
    const { value } = selectedOption;
    setChanged(true);
    setFormData({ ...formData, country: value});
    // Mettre à jour address.code
    setAddress(prevState => ({
      ...prevState,
      code: value
    }));
  
    // Requête pour récupérer les provinces
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${value}`)
      .then((response) => {
        //console.log(response.data.data);
        setProvinces(response.data.data);
      })
      .catch((err) => console.log(err));
  };
  

  const handleProvinceChange = (selectedOption) => {
    const { value } =selectedOption;
    setChanged(true);
    setFormData({ ...formData, province: value });
    setAddress(prevState=>({
      ...prevState,
      code_province:value
    }))

    //city
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${value}`)
      .then((response) => {
        setCities(response.data.data);
      })
      //.then(response => console.log(response.data.data))
      .catch((err) => console.log(err));
  };

  const handleCityChange = (selectedCity)=>{
    setFormData({ ...formData, ville: selectedCity.value });
    setAddress(prevCity=>({
      ...prevCity,
      code_city:selectedCity.value
    }))
}
  const checkboxClick= ()=>setShowInput(!showInput)

  useEffect(() => {
    if (!data) {
      navigate("/Connexion");
    }

     axios
        .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
        .then((res) => {
        if (res.data.status === 200 ) {
            setCurr(res.data.currency);
            localStorage.setItem('id_currency', res.data.currency.id_currency);
        } else {
            console.warn("Réponse inattendue de l'API :", res.data);
        }
        })
        .catch((err) => {
        console.error("Erreur lors de l'appel à l'API :", err);
        });

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/hebergement/show/${id}`)
      .then((response) => {
        setRecords(response.data.data);
        setTmpecords(response.data.data);
        //console.log(response.data.pictures)
        setPictures(response.data.pictures);
      })
      //.then(response => console.log(response))
      .catch((err) => console.log(err));

    //country
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/country/list`)
      .then((response) => {
        setCountries(response.data.data);
      })
      //.then(response => console.log(response.data.data))
      .catch((err) => console.log(err));

    //adresse
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/annonce/info/${id}`)
      .then((response) => {
        //console.log(response.data.data)
        setAddress(response.data.data);
      })
      .catch((err) => console.log(err));

    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes


    getPriceDollar();
    getPricePub();

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, []);

  useEffect(()=>{
    axios
    .get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${address.code}`)
    .then((response) => {
      //console.log(response.data.data);
      setProvinces(response.data.data);
    })
    .catch((err) => console.log(err));

     //city
     axios
     .get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${address.code_province}`)
     .then((response) => {
       setCities(response.data.data);
     })
     //.then(response => console.log(response.data.data))
     .catch((err) => console.log(err));

  },[address.code,address.code_province])

  const ValidatedEditForm = ()=>{
    fd.append("id", id);
    fd.append("nom", formData.name_h ?? records.title_announce);
    fd.append("type", formData.type ?? records.realstate_type);
    fd.append("methode", formData.methode ?? records.payment_method);
    fd.append("date", formData.date ?? records.realstate_move_in_date);
    fd.append("size", formData.perimetre ?? records.realstate_size);
    fd.append("lit", formData.bed_type ?? records.realstate_bedtype);
    fd.append("ascenseur", formData.ascenseur ?? records.realstate_elevator);
    fd.append("balcon", formData.balcon ?? records.realstate_balcony);
    fd.append("concierge", formData.concierge ?? records.realstate_concierge);
    fd.append("camera", formData.camera ?? records.realstate_security);
    fd.append( "clim",formData.climatiseur ?? records.realstate_air_conditioner);
    fd.append("meuble", formData.meuble ?? records.realstate_furnished);
    fd.append("desc", formData.msg ?? records.description_announce);
    fd.append("chambre", formData.nbre ?? records.realstate_number_pieces);
    fd.append("note", formData.note ?? records.note);
    fd.append("parking", formData.parking ?? records.realstate_parking);
    fd.append("piscine", formData.piscine ?? records.realstate_swimming_pool);
    fd.append("prix", formData.prix ?? records.price_announce);
    fd.append("wifi", formData.wifi ?? records.realstate_wifi);

    fd.append("adresse", formData.lieu ?? records.contact_address);
    fd.append("mail", formData.mail ?? records.contact_email);
    fd.append("tel", formData.phone ?? records.contact_phone);
    fd.append("pays", formData.country ?? records.contact_country); 
    fd.append("ville", formData.ville ?? records.contact_city);
    fd.append("province", formData.province ?? records.contact_province);
    fd.append("update",'edit');

    fd.append("date_debut", formData.date_debut ?? records.date_debut);
    fd.append("date_fin",formattedDate ?? records.date_fin);
    for (let i = 0; i < document.getElementById("photo")?.files.length; i++) {
      fd.append("photo[]", document.getElementById("photo")?.files[i]);
    }

    Heber.verifyForm(fd)
     // console.log("La date formater est " + formattedDate + " La date de fin est "  + tmprecords.date_fin)
     console.log(totalPaid)
         .then((res)=>{
           if(res.data.status === 422){
            setErrors(res.data.errors);
            setShowPopup(false)
            return;
           }else{
                 if(formattedDate === null || totalPaid === 0 )
                 {
                   SubmitEditForm();
                   navigate("/Dashboard/Publications/Hebergement/Voir_des_hebergements")
                   return;
                 }else{
                  setShowPopup(true)
                 }
                
           }
         }).catch((error)=>{
          console.log("Erreur lors de l'appel a l'Api ",error)
         })
  }

  const SubmitEditForm = (provider,paymentId,currencyId) => {
    fd.append("id", id);
    fd.append("nom", formData.name_h ?? records.title_announce);
    fd.append("type", formData.type ?? records.realstate_type);
    fd.append("methode", formData.methode ?? records.payment_method);
    fd.append("date", formData.date ?? records.realstate_move_in_date);
    fd.append("size", formData.perimetre ?? records.realstate_size);
    fd.append("lit", formData.bed_type ?? records.realstate_bedtype);
    fd.append("ascenseur", formData.ascenseur ?? records.realstate_elevator);
    fd.append("balcon", formData.balcon ?? records.realstate_balcony);
    fd.append("concierge", formData.concierge ?? records.realstate_concierge);
    fd.append("camera", formData.camera ?? records.realstate_security);
    fd.append( "clim",formData.climatiseur ?? records.realstate_air_conditioner);
    fd.append("meuble", formData.meuble ?? records.realstate_furnished);
    fd.append("desc", formData.msg ?? records.description_announce);
    fd.append("chambre", formData.nbre ?? records.realstate_number_pieces);
    fd.append("note", formData.note ?? records.note);
    fd.append("parking", formData.parking ?? records.realstate_parking);
    fd.append("piscine", formData.piscine ?? records.realstate_swimming_pool);
    fd.append("prix", formData.prix ?? records.price_announce);
    fd.append("wifi", formData.wifi ?? records.realstate_wifi);

    fd.append("adresse", formData.lieu ?? records.contact_address);
    fd.append("mail", formData.mail ?? records.contact_email);
    fd.append("tel", formData.phone ?? records.contact_phone);
    fd.append("pays", formData.country ?? records.contact_country);
    fd.append("ville", formData.ville ?? records.contact_city);
    fd.append("province", formData.province ?? records.contact_province);
    fd.append("update",'edit');

    fd.append("date_debut", formData.date_debut ?? records.date_debut);
    fd.append("date_fin",formattedDate ?? records.date_fin);
    for (let i = 0; i < document.getElementById("photo")?.files.length; i++) {
      fd.append("photo[]", document.getElementById("photo")?.files[i]);
    }
    
    Heber.submitForm(fd)
      .then((res) => {
        if (res.data.status === 201) {
          if(provider !== null && paymentId !== null && currencyId !== null){
                    const formD = {
                            userId:data.azId,
                            montant:totalPaid,
                            provider: provider,
                            payement_id:paymentId ,
                            currency:currencyId,
                            annonce_number: id,
                            description:"Transaction de modification d'un hebergement"
                        }
                    axios.post(`${process.env.REACT_APP_BASE_URL}/api/store/rechargement-paiememnt`,formD)
                        .then((res)=>{
                        if(res.data.status === 200){
                        //toast.success(res.data.message);
                        //console.log("enregistrement reussie")
                        }
                        }).catch((err)=>{
                        console.log("Erreur lors de l'appel a l'API ",err)
                        })
            }
          toast.success(res.data.message);
          navigate("/Dashboard/Publications/Hebergement/Voir_des_hebergements");
        } else if(res.data.status === 404) {
          toast.error(res.data.message);
        }else if(res.data.status === 500){
          toast.error(res.data.error);
        }
        //navigate("/Dashboard/Publications/Hebergement/Voir_des_hebergements");
      })
      .catch((err) => {
        toast.error("Erreur merci de reessayer !");
        console.log(err);
      })
      .finally(() => {
        //setLoading(false);
      });
  };

  const handleSubmit = (event)=>{
    event.preventDefault();
     ValidatedEditForm();
  }
 

const [formattedDate, setFormattedDate] = useState(null);
const [totalPaid, setTotalPaid] = useState(null);

let daysToAdd= null;
const handleDaysChange = (event) => {
   daysToAdd = parseInt(event.target.value, 10); // Assurez-vous que la valeur est bien un nombre
  if (!isNaN(daysToAdd)) {

    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toISOString().split('T')[0];
    let updatedEndDate = null;
    let DateBeforEnd = null;
    if(tmprecords.date_fin < formattedCurrentDate)
    {
        updatedEndDate = new Date(formattedCurrentDate);
    }else{
        updatedEndDate = new Date(tmprecords.date_fin);
        DateBeforEnd = new Date(tmprecords.date_fin).getDate() - new Date(formattedCurrentDate).getDate() 
    }
   
    setDayr(DateBeforEnd + daysToAdd)

    // Créez une copie de endDate pour éviter de modifier l'original à chaque changement
    updatedEndDate.setDate(updatedEndDate.getDate() + daysToAdd);

    const newFormattedDate = `${updatedEndDate.getFullYear()}-${(updatedEndDate.getMonth() + 1).toString().padStart(2, '0')}-${updatedEndDate.getDate().toString().padStart(2, '0')}`;
    setFormattedDate(newFormattedDate);  // Mise à jour de formattedDate
  }
};

useEffect(() => {
  if (formattedDate !== null) {
    
    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toISOString().split('T')[0];
    let dateDiffInDays = null;
    if(tmprecords.date_fin < formattedCurrentDate)
    {
         dateDiffInDays = (new Date(formattedDate) - new Date(formattedCurrentDate)) / (1000 * 60 * 60 * 24);

    }else{
         dateDiffInDays = (new Date(formattedDate) - new Date(tmprecords.date_fin)) / (1000 * 60 * 60 * 24);
    }
    setTotalPaid(parseFloat(pricePub) * Math.ceil(dateDiffInDays));  // Mise à jour de totalPaid
  }
}, [formattedDate]);

 useEffect(() => {
            if (curr) {
        
            setOptions({
                id_currency: curr.id_currency,
                success_url: window.location.origin ,
                cancel_url: window.location.href,
                amount:totalPaid,
                customer: {
                id: data.azId,
                first_name: data.userLastname ?? '',
                last_name: data.userName ?? '',
                email: data.userMail,
                phone: data.userTel,
                code_country: 'BJ'
                },
                seller_number: 1
            });
            }
  }, [curr,totalPaid]);
    

const handleDeleteImage = async (id,idImage)=>{
   await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/hebergement/delete/${id}/${idImage}`)
         .then((res)=>{
            if(res.data.status === 200)
            {
                setPictures(res.data.pictures)
                toast.success("Image supprimer avec success")
                return;
            }
            if(res.data.status === 422)
            {
                toast.success(res.data.message)
                return;
            }
         }).catch((err)=>{
            console.log("Erreur lors de l'appel a l'API ",err)
         })
}

const {t} = useTranslation()
const lang = localStorage.getItem("langague");

//console.log(tmprecords.realstate_move_in_date)



  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          {/* sidebar left */}

          <div className="w-screen h-screen barre_scroll">
            {/* navbar top orange */}
            <SidebarTop />
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  {t("Mes publications")}
                </Link>
                <Link
                  to="/Dashboard/Publications/Hebergement/Voir_des_hebergements"
                  className="opacity-60 md:text-base s:text-xs"
                >
                  {t("Hebergements")}
                </Link>
                <Link to="" className="md:text-base s:text-xs">
                  {t("Modifier")}
                </Link>
              </Breadcrumbs>
            </div>

            <div>
              <ToastContainer />
            </div>

            <Link to="/Dashboard/Publications/Hebergement/Voir_des_hebergements">
              <div className="flex flex-row items-center space-x-2 relative top-8 s:left-5 sm:left-12 w-[280px]">
                <GoArrowLeft className="text-[#fe7f2d]  text-lg" />
                <p>{t("Retour à la page précedente")}</p>
              </div>
            </Link>
            {/* container formulaire */}
            <div className="flex justify-center py-20 ">
              <form
                onSubmit={handleSubmit}
                className="flex flex-col items-center space-y-3 "
              >
                <div className="bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* nom d'apartement */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineHomeWork className="text-xl text-[#fe7f2d]" />
                      <label>{t("Nom")}</label>
                    </div>
                    <input
                      defaultValue={tmprecords.title_announce}
                      onChange={handleInputChange}
                      type="text"
                      name="name_h"
                      placeholder="Ex : Villa la joie"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.nom && <p className='text-red-500'>{errors.nom}</p>}
                  </div>
                  {/* Ajout des images */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineAddPhotoAlternate className="text-xl text-[#fe7f2d]" />
                      <label> {t("Ajouter des images")}</label>
                      <div onClick={()=>setOpen(true)}  className="text-blue-500 cursor-pointer ">
                        {pictures.length + t(" files")}
                      </div>

                    </div>
                    <input
                      onChange={handleInputChange}
                      type="file"
                      accept="image/*"
                      multiple
                      id="photo"
                      name="photo"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 "
                    />
                  </div>
                  {/* Type de paiement */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlinePayment className="text-xl text-[#fe7f2d]" />
                      <label>{t("Méthode de paiement")}</label>
                    </div>
                    <select
                      onChange={handleInputChange}
                      name="methode"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                      required
                    >
                      <option value=""></option>
                      {tmprecords.payment_method === 1 ? (
                        <option value="1" selected>
                          {t("Paiement en ligne et sur place")}
                        </option>
                      ) : (
                        <option value="1">
                          {t("Paiement en ligne et sur place")}
                        </option>
                      )}

                      {tmprecords.payment_method === 2 ? (
                        <option value="2" selected>
                          {t("Paiement en ligne")}
                        </option>
                      ) : (
                        <option value="2">{t("Paiement en ligne")}</option>
                      )}

                      {tmprecords.payment_method === 3 ? (
                        <option value="3" selected>
                          {t("Paiement sur place")}
                        </option>
                      ) : (
                        <option value="3">{t("Paiement sur place")}</option>
                      )}
                    </select>
                    {errors.methode && <p className='text-red-500'>{errors.methode}</p>}
                  </div>
                  {/* Type */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineHomeWork className="text-xl text-[#fe7f2d]" />
                      <label>Type</label>
                    </div>
                    <select
                      onChange={handleInputChange}
                      name="type"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                      required
                    >
                      <option value=""></option>
                      {tmprecords.realstate_type === "other" ? (
                        <option value="other" selected>
                          {t("Autre")}
                        </option>
                      ) : (
                        <option value="other">{t("Autre")}</option>
                      )}
                      {tmprecords.realstate_type === "house" ? (
                        <option value="house" selected>
                          {t("Maison")}
                        </option>
                      ) : (
                        <option value="house">{t("Maison")}</option>
                      )}
                      {tmprecords.realstate_type === "hotel" ? (
                        <option value="hotel" selected>
                          Hotel
                        </option>
                      ) : (
                        <option value="hotel">Hotel</option>
                      )}
                      {tmprecords.realstate_type === "appartment" ? (
                        <option value="appartment" selected>
                          {t("Appartement")}
                        </option>
                      ) : (
                        <option value="appartment">{t("Appartement")}</option>
                      )}
                    </select>
                    {errors.type && <p className='text-red-500'>{errors.type}</p>}
                  </div>
                  {/* nombre de la chambre */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <BiHotel className="text-xl text-[#fe7f2d]" />
                      <label>{t("Nombres de pièces")}</label>
                    </div>
                    <input
                      defaultValue={tmprecords.realstate_number_pieces}
                      onChange={handleInputChange}
                      required
                      type="number"
                      name="nbre"
                      placeholder="Ex : 2 "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.chambre && <p className="text-red-500">{errors.chambre}</p>}
                  </div>
                  {/* perimetre chambre */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <RxDimensions className="text-xl text-[#fe7f2d]" />
                      <label>{t("Périmetre")}(m²)</label>
                    </div>
                    <input
                      defaultValue={tmprecords.realstate_size}
                      onChange={handleInputChange}
                      type="number"
                      name="perimetre"
                      placeholder="Ex : 40 "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.perimetre && <p className="text-red-500">{errors.perimetre}</p>}
                  </div>
                  {/* Type de lit */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoBedOutline className="text-xl text-[#fe7f2d]" />
                      <label>{t("Type de lit")}</label>
                    </div>
                    <select
                      onChange={handleInputChange}
                      name="bed_type"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value=""></option>
                      {tmprecords.realstate_bedtype === "Lit simple" ? (
                        <option value="Lit simple" selected>
                          {t("Lit simple")}
                        </option>
                      ) : (
                        <option value="Lit simple">{t("Lit simple")}</option>
                      )}
                      {tmprecords.realstate_bedtype === "Lit double" ? (
                        <option value="Lit double" selected>
                          {t("Lit double")}
                        </option>
                      ) : (
                        <option value="Lit double">{t("Lit double")}</option>
                      )}
                      {tmprecords.realstate_bedtype === "Lit triple" ? (
                        <option value="Lit triple" selected>
                          {t("Lit triple")}
                        </option>
                      ) : (
                        <option value="Lit triple">{t("Lit triple")}</option>
                      )}
                    </select>
                    {errors.lit && <p className='text-red-500'>{errors.lit}</p>}
                  </div>
                </div>

                <div className="bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Tel */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <FaPhoneAlt className=" text-[#fe7f2d]" />
                      <label>{t("Telephone")}</label>
                    </div>
                    <input
                      type="tel"
                      defaultValue={tmprecords.contact_phone}
                      name="phone"
                      onChange={handleInputChange}
                      placeholder="Ex : +225 xxx xxx xxxx "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.tel && <p className="text-red-500">{errors.tel}</p>}
                  </div>
                  {/* Mail */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoIosMail className=" text-[#fe7f2d]" />
                      <label>{t("Adresse e-mail")}</label>
                    </div>
                    <input
                      type="email"
                      defaultValue={tmprecords.contact_email}
                      name="mail"
                      onChange={handleInputChange}
                      placeholder="Ex : info@monbonsejour.com "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.mail && <p className="text-red-500">{errors.mail}</p>}
                  </div>
                  {/* Country */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Pays")}</label>
                    </div>
                      <Form.Group>
                          <Select
                              onChange={handleCountryChange}
                              name="country"  
                              value={address.code ? { 
                                    label: lang === 'fr' ? countries.find(pay => pay?.code === address.code)?.fr_Name
                                    :countries.find(pay => pay?.code === address.code)?.Name,
                                    value: address.code } : null} // Inclut la propriété value
                              options={countries.map(pay => ({
                                  label: lang === 'fr' ? pay?.fr_Name :  pay?.Name,
                                  value: pay?.code
                              }))}
                              className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                          />
                      </Form.Group>
                    {/* <select
                      onChange={handleCountryChange}
                      required
                      name="country"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code}>{address.fr_Name}</option>
                      {countries.map((option, index) => (
                        <option key={index} value={option.code}>
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.pays && <p className='text-red-500'>{errors.pays}</p>}
                  </div>
                  {/* Province */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Province")}</label>
                    </div>
                     <Form.Group>
                          <Select
                              onChange={handleProvinceChange}
                              name="province"  
                              value={address.code_province ? { 
                                    label:lang === 'fr' ? provinces.find(prov => prov?.code_province === address.code_province)?.fr_Name
                                    :provinces.find(prov => prov?.code_province === address.code_province)?.Name,
                                     value: address.code_province} : null} // Inclut la propriété value
                              options={provinces.map(prov => ({
                                  label: lang === 'fr' ? prov?.fr_Name : prov?.Name,
                                  value: prov?.code_province
                              }))}
                              className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                          />
                    </Form.Group>

                    {/* <select
                      onChange={handleProvinceChange}
                      required
                      name="province"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code_province}>
                        {address.pname}
                      </option>
                      {provinces.map((option, index) => (
                        <option key={index} value={option.code_province}>
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.province && <p className='text-red-500'>{errors.province}</p>}
                  </div>
                  {/* Ville */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Ville")}</label>
                    </div>
                     <Form.Group>
                            <Select
                                onChange={handleCityChange}
                                name="ville"  
                                value={address.code_city ? { 
                                       label:lang === 'fr' ? cities.find(city => city?.code_city === address.code_city)?.fr_Name
                                       : cities.find(city => city?.code_city === address.code_city)?.Name,
                                        value: address.code_city} : null} // Inclut la propriété value
                                options={cities.map(city => ({
                                    label: lang === 'fr' ? city?.fr_Name : city?.Name ,
                                    value: city?.code_city
                                }))}
                                className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                            />
                    </Form.Group> 
                    {/* <select
                      onChange={handleInputChange}
                      required
                      name="ville"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code_city}>{address.cname}</option>
                      {cities.map((option, index) => (
                        <option
                          key={index}
                          value={option.code_city}
                          selected={
                            option.code_city === tmprecords.contact_city
                              ? true
                              : false
                          }
                        >
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.ville && <p className='text-red-500'>{errors.ville}</p>}
                  </div>
                  {/* Lieu */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Lieu")}</label>
                    </div>
                    <input
                      type="text"
                      defaultValue={tmprecords.contact_address}
                      name="lieu"
                      onChange={handleInputChange}
                      placeholder="Ex : Cocody, Abidjan, Côte d'ivoire "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.adresse && <p className='text-red-500'>{errors.adresse}</p>}
                  </div>
                </div>

                <div className="bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* caractéristique de la chambre */}
                  <p className="text-lg font-semibold">
                    {t("Dans votre appartement ou chambre")}
                  </p>
                  <div className="grid s:grid-cols-2 sm:grid-cols-3 xs:grid-cols-3 gap-y-8">
                    {/* piscine */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <MdOutlinePool className="text-xl text-[#fe7f2d]" />
                        <label>{t("Piscine")}</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_swimming_pool === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="piscine"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="piscine"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_swimming_pool === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="piscine"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="piscine"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.piscine && <p className="text-red-500">{errors.piscine}</p>}
                      </div>
                    </div>
                    {/* Wifi  */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <MdOutlineWifi className="text-xl text-[#fe7f2d]" />
                        <label>{t("Wifi")} </label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_wifi === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="wifi"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="wifi"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_wifi === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="wifi"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="wifi"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.wifi && <p className='text-red-500'>{errors.wifi}</p>}
                      </div>
                    </div>
                    {/* TV */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <GiCctvCamera className="text-xl text-[#fe7f2d]" />
                        <label>Cameras</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_security === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="camera"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="camera"
                            value="1"
                          />
                        )}
                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_security === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="camera"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="camera"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.camera && <p className='text-red-500'>{errors.camera}</p>}
                      </div>
                    </div>
                    {/* Pétit déjeuner */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <MdBalcony className="text-xl text-[#fe7f2d]" />
                        <label>{t("Balcon")}</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_balcony === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="balcon"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="balcon"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_balcony === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="balcon"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="balcon"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.balcon && <p className='text-red-500'>{errors.balcon}</p>}
                      </div>
                    </div>
                    {/* Micro onde */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <MdElevator className="text-xl text-[#fe7f2d]" />
                        <label>{t("Ascenseur")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_elevator === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="ascenseur"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="ascenseur"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_elevator === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="ascenseur"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="ascenseur"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.ascenseur && <p className="text-red-500">{errors.ascenseur}</p>}
                      </div>
                    </div>
                    {/* Baignoire */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <FaBellConcierge className="text-xl text-[#fe7f2d]" />
                        <label>Conciegre</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_concierge === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="concierge"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="concierge"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_concierge === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="concierge"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="concierge"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.concierge && <p className='text-red-500'>{errors.concierge}</p>}
                      </div>
                    </div>
                    {/* Ustensile de cuisine */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <RiParkingBoxFill className="text-xl text-[#fe7f2d]" />
                        <label>Parking</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_parking === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="parking"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="parking"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_parking === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="parking"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="parking"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.parking && <p className="text-red-500">{errors.parking}</p>}
                      </div>
                    </div>
                    {/* frigo */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <MdOutlineSevereCold className="text-xl text-[#fe7f2d]" />
                        <label>{t("Climatiseur")}</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_air_conditioner === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="climatiseur"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="climatiseur"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_air_conditioner === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="climatiseur"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="climatiseur"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.clim && <p className="text-red-500">{errors.clim}</p>}
                      </div>
                    </div>
                    {/* frigo */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <LuArmchair className="text-xl text-[#fe7f2d]" />
                        <label>{t("Meublé")}</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_furnished === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            defaultChecked={true}
                            name="meuble"
                            value="1"
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="meuble"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_furnished === 0 ? (
                          <input
                            onChange={handleInputChange}
                            defaultChecked={true}
                            type="radio"
                            name="meuble"
                            value="0"
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="meuble"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.meuble && <p className="text-red-500">{errors.meuble}</p>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* nombre de personne */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>{t("Date de disponibilité")}</label>
                    </div>
                    <input
                      defaultValue={tmprecords.realstate_move_in_date}
                      name="date"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      required
                    />
                    {errors.date && <p className='text-red-500'>{errors.date}</p>}
                  </div>
                  {/* équipement */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineRoomPreferences className=" text-[#fe7f2d]" />
                      <label>{t("Équipements")}</label>
                    </div>
                    <input
                      defaultValue={tmprecords.note}
                      type="text"
                      onChange={handleInputChange}
                      name="note"
                      placeholder="Ex : Bureau, Machine à café, Minibar, Fer à rapasser, Netflix, Canal+ "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.note && <p className='text-red-500'>{errors.note}</p>}
                  </div>
                  {/* Tarif */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <GiMoneyStack className="text-xl text-[#fe7f2d]" />
                      <label>{t("Tarif")}</label>
                    </div>
                    <input
                      defaultValue={tmprecords.price_announce}
                      onChange={handleInputChange}
                      type="number"
                      name="prix"
                      required
                      placeholder="Ex : 70000 "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.prix && <p className='text-red-500'>{errors.prix}</p>}
                    <small>{t("Le tarif doit être par nuitée")}</small>
                  </div>
                  {/* Description */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <AiOutlineEdit className="text-xl text-[#fe7f2d]" />
                      <label>{t("Description de la chambre")}</label>
                    </div>
                    <textarea
                      defaultValue={tmprecords.description_announce}
                      onChange={handleInputChange}
                      name="msg"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] rounded p-2 h-[200px]"
                    ></textarea>
                    {errors.desc && <p className='text-red-500'>{errors.desc}</p>}
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* date debut */}
                  {/* <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>Date de debut affichage</label>
                    </div>
                    <input
                      defaultValue={tmprecords.date_debut}
                      name="date_debut"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      required
                    />
                    {errors.date_debut && <p className='text-red-500'>{errors.date_debut}</p>}
                  </div> */}
                     
                  {/* date fin */}
                  {/* <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>Date de fin affichage</label>
                    </div>
                    <input
                      defaultValue={tmprecords.date_fin}
                      name="date_fin"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      required
                    />
                    {errors.date_fin && <p className="text-red-500">{errors.date_fin}</p>}
                  </div> */}
                  <div className="flex flex-row items-center space-x-2">
                      <input
                        onClick={checkboxClick}
                        type="checkbox"                       
                      />
                      <label>{t("Ajouter des jours")}?</label>
                   </div>
                   {
                    showInput &&(
                        <input
                        type="text"
                        name="days"
                        onChange={handleDaysChange}
                        placeholder={t("Entrer le nombre de jours que vous voulez?")}
                        className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      />
                    )
                   }
                   
                   <div className="bg-blue-900 rounded-lg shadow-lg p-6 text-white max-w-md mx-auto my-4">
                    <h3 className="text-xl font-semibold mb-4 border-b border-blue-700 pb-2">{t("Affichage")}:</h3>
                    <div className="space-y-2">
                      <div className="flex items-center">
                        <span className="font-medium w-32">{t("Date de début")}:</span>
                        <span className="bg-blue-800 px-3 py-1 rounded">
                          {new Date(tmprecords.date_debut).toLocaleDateString('fr-FR')}
                        </span>
                      </div>
                      <div className="flex items-center">
                      <span className="font-medium w-32">{t("Date de fin")}:</span>
                        <span className="bg-blue-800 px-3 py-1 rounded">
                          {new Date(tmprecords.date_fin).toLocaleDateString(
                            "fr-FR"
                          )}
                        </span>
                      </div>
                      {
                        !isNaN(daysToAdd) && new Date(formattedDate).toLocaleDateString("fr-FR") !== "01/01/1970"  && (
                          <>
                               <div className="mb-4 border-b border-blue-700 pb-2 flex items-center">
                                <span className="font-medium w-32">{t("Nouvelle")} <br/> {t("date de fin")}:</span>
                                  <span className="bg-blue-800 px-3 py-1 rounded">
                                    {new Date(formattedDate).toLocaleDateString(
                                      "fr-FR"
                                    )}
                                  </span>
                              </div>
                              <div className="flex items-center">
                              <span className="font-medium w-32">{t("Nombre de")}  <br/> {t("jour(s) restant")}:</span>
                                <span className="bg-blue-800 px-3 py-1 rounded">
                                  {dayr}
                                </span>
                              </div>
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>

                <button className="bg-[#FCCA46] w-[150px] h-10 rounded text-white">
                  {t("Modifier")}
                </button>

                {/* {showPopup && (
                    <PaymentPopup
                        open={showPopup}
                        montant={totalPaid}
                        onSuccess={handlePopupSuccess}
                        userNom={data.userLastname}
                        userPrenom={data.userName}
                        email={data.userMail}
                        user_Id={data.userId}
                        dollarP={Math.round(priceD)}
                        onCancel={handlePopupCancel}
                    />
                )} */}
                
              </form>

               {
                  showPopup && (
                  <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                          {/* Bouton de fermeture à l'intérieur du modal */}
                          <button
                          onClick={() => setOpen(false)}
                          className="absolute top-3 right-3 text-red-500 text-2xl"
                      >
                          &times;
                      </button>
                          <Create item="Rechargement de la carte AZ"  options={options} onSuccess={SubmitEditForm} ></Create>
                      </div>
                  </div>
                  )
               }

              {/** Modal d'image */}
              {
                open && (
                  <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                      {/* Bouton de fermeture à l'intérieur du modal */}
                      <button
                        onClick={() => setOpen(false)}
                        className="absolute top-3 right-3 text-red-500 text-2xl"
                      >
                        &times;
                      </button>
                      
                      <h2 className="text-center text-xl font-semibold mb-4">{t("Les images de")} {tmprecords.title_announce}</h2>
                      
                      <div className="grid grid-cols-3 gap-4">
                        {pictures.map((picture, index) => (
                          <div key={index} className="relative">
                            <img
                              src={`data:image/png;base64,${picture.picture}`} 
                              alt="image preview"
                              className="w-full h-auto rounded-lg"
                            />
                            <button
                              onClick={() => handleDeleteImage(id, picture.id)} // Logic to remove image (if implemented)
                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1"
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )
              }


            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default EditHebergement;
